import { render, staticRenderFns } from "./ListView.vue?vue&type=template&id=0b0066e7&"
import script from "./ListView.vue?vue&type=script&lang=js&"
export * from "./ListView.vue?vue&type=script&lang=js&"
import style0 from "./ListView.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/carolinethuelarsen/Documents/development/ibg-screen-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b0066e7')) {
      api.createRecord('0b0066e7', component.options)
    } else {
      api.reload('0b0066e7', component.options)
    }
    module.hot.accept("./ListView.vue?vue&type=template&id=0b0066e7&", function () {
      api.rerender('0b0066e7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/generic/ListView.vue"
export default component.exports